import { useState } from "react";
import { twMerge } from "tailwind-merge";
import { ImageLightbox } from "@components/ImageLightbox";
import { ImageLightboxItem } from "../types/ImageTypes";

interface ImageGalleryProps {
  images: ImageLightboxItem[];
  rowCount: string;
}

export const ImageGallery = ({ images, rowCount }: ImageGalleryProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalImage, setModalImage] = useState<ImageLightboxItem | null>(null);
  const [currentImageIndex, setCurrentImageIndex] = useState<number>(0);

  return (
    <div
      className={twMerge(
        "my-14 grid grid-cols-2 gap-4",
        rowCount === "2" ? "lg:grid-cols-2" : "",
        rowCount === "3" ? "lg:grid-cols-3" : "",
        rowCount === "4" ? "lg:grid-cols-4" : ""
      )}
    >
      {images.map((image, index) => (
        <button
          key={image.id}
          onClick={() => {
            setIsModalOpen(true);
            setModalImage(image);
            setCurrentImageIndex(index);
          }}
          className="hover:cursor-pointer"
        >
          <img
            src={image.image}
            alt={image.alt ?? ""}
            className="h-full w-full object-cover"
          />
        </button>
      ))}

      {isModalOpen && modalImage && (
        <ImageLightbox
          isModalOpen={isModalOpen}
          setIsModalOpen={setIsModalOpen}
          modalImage={modalImage}
          setModalImage={setModalImage}
          images={images}
          currentImageIndex={currentImageIndex}
          setCurrentImageIndex={setCurrentImageIndex}
        />
      )}
    </div>
  );
};
